export default {
  computed: {
    stateCity: {
      get: function() {
        if (this.editModel.State && this.address.locality) {
          return this.address.locality;
        } else if (this.editModel.State) {
          return this.editModel.State;
        } else if (this.address.locality) {
          return this.address.locality;
        } else {
          return "";
        }
      },
      set: function(newValue) {
        var names = newValue.split("/");
        if (names.length == 1) {
          this.editModel.State = newValue;
        } else if (names.length == 2) {
          this.editModel.State = names[0];
        } else {
          this.editModel.State = names[1];
        }
      },
    },
    isAddressInputValid() {
      return (
        this.editModel.StreetAddress && this.editModel.StreetAddress.length > 0
      );
    },
    isDoorDashEnabled() {
      return this.selectedCompany &&
        this.selectedCompany.EnableThirdPartyDelivery &&
        this.selectedCompany.EnableThirdPartyDelivery.DoorDash;
    },
  },

  methods: {
    validatePostcode(postal_code) {
      if (this.isGift || this.selectedCompany.DeliveryAreaZones) return true;
      if (postal_code == "") {
        this.isDeliveryAreaValid = true;
        return true;
      }
      var found = false;
      if (!this.selectedCompany.DeliveryAreas) {
        return true;
      }
      if (this.selectedCompany.DeliveryAreas.length == 0) {
        return true;
      }
      this.selectedCompany.DeliveryAreas.forEach((item) => {
        var fromPostcode = item.PostcodeFrom;
        var toPostcode = item.PostcodeTo;
        var from = parseInt(fromPostcode);
        var to = parseInt(toPostcode);
        if (postal_code >= from && postal_code <= to) {
          found = true;
        }
      });
      this.isDeliveryAreaValid = found;
      this.$emit("postalCodeUpdate");
      return found;
    },
    async getAddressData(addressData, placeResultData) {
      this.editModel.address = this.$refs.gAutoComplete.$el.value;
      let componentFormInfo = {
        postal_code: {
          fieldName: "PostalCode",
          property: "short_name",
          fieldType: "1",
        },
        administrative_area_level_1: {
          fieldName: "State",
          property: "short_name",
          fieldType: "1",
        },
        locality: {
          fieldName: "locality",
          property: "long_name",
          fieldType: "0",
        },
        route: { fieldName: "route", property: "long_name", fieldType: "0" },
        street_number: {
          fieldName: "street_number",
          property: "short_name",
          fieldType: "0",
        },
      };

      this.editModel.Latitude = null;
      this.editModel.Longitude = null;
      this.editModel.Country = addressData.country;
      this.editModel.StreetAddress = this.$refs.gAutoComplete.$el.value;

      if (
        placeResultData &&
        placeResultData.geometry &&
        placeResultData.geometry.location
      ) {
        if (placeResultData.geometry.location.lat) {
          this.editModel.Latitude = placeResultData.geometry.location
            .lat()
            .toString();
        }
        if (placeResultData.geometry.location.lng) {
          this.editModel.Longitude = placeResultData.geometry.location
            .lng()
            .toString();
        }
      }

      for (var i = 0; i < placeResultData.address_components.length; i++) {
        var addressType = placeResultData.address_components[i].types[0];

        if (componentFormInfo[addressType]) {
          var val =
            placeResultData.address_components[i][
              componentFormInfo[addressType].property
            ];

          if (componentFormInfo[addressType].fieldType == "1")
            this.editModel[componentFormInfo[addressType].fieldName] = val;
          else if (componentFormInfo[addressType].fieldType == "0")
            this.address[componentFormInfo[addressType].fieldName] = val;
        }
      }
      this.validatePostcode(this.editModel.PostalCode);
      this.editModel.CityTown = this.stateCity;
      if(this.isDoorDashEnabled) {
        this.editModel.StreetAddress = [
          this.address.street_number,
          this.address.route,
        ].join(' ').trim();
        this.addressChanged();
      }
      await this.applyDeliveryAddress({
        address: this.editModel,
        isUpdateDeliverAddress: true,
      });
      this.$emit("estimationUpdated", true);
      this.isDeliveryAddressValid = true;
      this.$forceUpdate();
    },
    validate() {
      return this.$validator.validateAll();
    },
    handleError(error) {
      throw error;
    },
    addressChanged() {
      if (this.editModel.StreetAddress) {
        document.getElementById(
          "OO_addressinput"
        ).value = this.editModel.StreetAddress;
      }
    },
  },
};
